import React from "react";

const PersonalAssessmentDetail = ({ item }) => {
    return (
        <>
            <table className="table table-bordered">
                <tbody>
                    {item.questions.map(option => (
                        <tr key={option.key}>
                            <td style={{ width: "40%" }}>
                                <strong>{option.key}</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <span className="text-primary">{option.value}</span>
                            </td>
                        </tr>
                    ))}

                    <tr>
                        <td style={{ width: "40%" }}>
                            <strong>Health State</strong>
                        </td>
                        <td style={{ width: "60%" }}>
                            <span className="text-primary">{item.health_state}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    );
};

export default PersonalAssessmentDetail;
